import { RelayClientTransport } from '~/modules/remote-mic/network/client/transport/relay-client-transport';
import { MIC_RELAY_SERVER } from '~/modules/remote-mic/network/server/transport/mic-relay-server';

export class MicRelayClientTransport extends RelayClientTransport {
  protected getUrl = (roomId: string) => `${MIC_RELAY_SERVER}/parties/mic/${roomId}`;
}
